import ContentFilter from "@material-ui/icons/FilterList";
import React from "react";
import { SelectInput } from 'react-admin';
import { Form } from "react-final-form";
import { Box, Button } from "@material-ui/core";
import ContractStatuses from "../helper/ContractStatuses";

const FilterButton = ({ showFilter }) => (
    <Button
        size="small"
        color="primary"
        onClick={() => showFilter("main")}
        startIcon={<ContentFilter />}
    >
        Фільтр
    </Button>
);

const FilterForm = ({
                        displayedFilters,
                        filterValues,
                        setFilters,
                        hideFilter,
                        open
                    }) => {
    if (!displayedFilters.main) {
        return null;
    }

    const onSubmit = values => {
        if (Object.keys(values).length > 0) {
            setFilters(values);
        } else {
            hideFilter("main");
        }
    };

    const resetFilter = () => {
        setFilters({}, []);
    };

    return (
        <div>
            <Form onSubmit={onSubmit} initialValues={filterValues}>
                {({ handleSubmit }) => (
                    <form onSubmit={handleSubmit}>
                        <Box mt={2} />
                        <Box display="flex" alignItems="flex-end" mb={1}>
                            <Box component="span" mr={2}>
                                <SelectInput label="Статус" source="status"
                                    choices={ContractStatuses}
                                />
                            </Box>
                            <Box component="span" mr={2}>
                                <SelectInput label="Мед. програма" source="medical_program_id"
                                   choices={[
                                       {id: '63c1f32f-c8f4-4f5b-81a9-79b8452d6545', name: 'Серцево-судинні та цереброваскулярні захворювання, цукровий діабет 2-го типу та хронічні хвороби нижніх дихальних шляхів'},
                                       {id: '8a11c513-e7a9-4800-9fb9-becb743e08c4', name: 'Імуносупресивні лікарські засоби'},
                                       {id: '14e19712-b443-4391-b0f7-aba8e8662459', name: 'Нецукровий діабет'},
                                       {id: 'f217889f-736f-462c-8f8b-ed99edddb3be', name: 'Розлади психіки та поведінки'},
                                       {id: '9d94a21b-ec70-4b91-946a-981f4db8d2b9', name: 'Епілепсія'},
                                       {id: '0eececf1-aaf5-48fb-87e2-da44b7c49db2', name: 'Хвороба Паркінсона'},
                                       {id: '857588d8-9e12-4935-96c4-b08e95d19dce', name: 'Інсуліни людські (картриджи та шприцручки з доплатою)'},
                                       {id: '8efe29df-18bd-4d49-8995-c3f7e44d9e12', name: 'Інсуліни людські (картриджи та шприцручки безоплатно)'},
                                       {id: 'cda113e4-b8dd-4ec4-a878-3d1c7eae49da', name: 'Інсуліни людські (флакони безоплатно)'},
                                       {id: 'e9c6beeb-b19f-4b97-b42a-020c5c996c56', name: 'Інсуліни аналоги (з доплатою)'},
                                       {id: '7335a30e-61f2-42b0-9ed4-2afe847bba16', name: 'Інсуліни аналоги (безоплатно)'},
                                       {id: '5562904e-100f-11ee-be56-0242ac120002', name: 'Опіоїдні анальгетики'},
                                       {id: '9723a9a0-100a-11ee-be56-0242ac120002', name: 'Опіоїдні анальгетики для лікування РПП'},
                                       {id: '0cefbce3-6dd2-45bd-b1e6-983fc055d5e0', name: 'Медичні вироби для визначення рівня глюкози в крові'}
                                   ]}
                                />
                            </Box>
                            <Box component="span" mr={2} mb={4.1}>
                                <Button variant="outlined" color="primary" type="submit">
                                    Показати
                                </Button>
                            </Box>
                            <Box component="span" mb={4.1}>
                                <Button variant="outlined" onClick={resetFilter}>
                                    Закрити
                                </Button>
                            </Box>
                        </Box>
                    </form>
                )}
            </Form>
        </div>
    );
};

const Filter = props => {
    return props.context === "button" ? (
        <FilterButton {...props} />
    ) : (
        <FilterForm {...props} />
    )
};

export default Filter;